<template>
  <div class="password-page-container">
    <PageHeader :title="pageTitle" />

    <div v-if="_g_UserId != 0" class="password-content card">
      <div class="form-group">
        <label for="old_password">Contraseña actual</label>
        <div class="password-input-wrapper">
          <input id="old_password" v-model="old_password" class="form-input"
            :type="show_old_password ? 'text' : 'password'">
          <i class="material-icons toggle-password-visibility" @click="toggleVisibility('show_old_password')">
            {{ show_old_password ? 'visibility_off' : 'visibility' }}
          </i>
        </div>
      </div>

      <div class="form-group">
        <label for="new_password">Nueva contraseña</label>
        <div class="password-input-wrapper">
          <input id="new_password" v-model="new_password" class="form-input"
            :type="show_new_password ? 'text' : 'password'">
          <i class="material-icons toggle-password-visibility" @click="toggleVisibility('show_new_password')">
            {{ show_new_password ? 'visibility_off' : 'visibility' }}
          </i>
        </div>
      </div>

      <div class="form-group">
        <label for="confirm_new_password">Confirmar nueva contraseña</label>
        <div class="password-input-wrapper">
          <input id="confirm_new_password" v-model="confirm_new_password" class="form-input"
            :type="show_confirm_password ? 'text' : 'password'">
          <i class="material-icons toggle-password-visibility" @click="toggleVisibility('show_confirm_password')">
            {{ show_confirm_password ? 'visibility_off' : 'visibility' }}
          </i>
        </div>
      </div>

      <div class="form-group checkbox-item">
        <input id="confirm_change" v-model="confirm_change" type="checkbox" class="form-checkbox">
        <label for="confirm_change">Estoy seguro de que quiero cambiar mi contraseña</label>
      </div>

      <button @click="changePassword" class="btn btn--primary btn--full-width">GUARDAR</button>
    </div>

    <div v-else class="password-content card">
      <div v-if="url_flag">
        <div class="form-group">
          <label for="user_email">Correo electrónico</label>
          <input id="user_email" v-model="user_email" type="email" class="form-input">
        </div>

        <div class="form-group">
          <label for="reset_new_password">Nueva contraseña</label>
          <div class="password-input-wrapper">
            <input id="reset_new_password" v-model="new_password" class="form-input"
              :type="show_new_password ? 'text' : 'password'">
            <i class="material-icons toggle-password-visibility" @click="toggleVisibility('show_new_password')">
              {{ show_new_password ? 'visibility_off' : 'visibility' }}
            </i>
          </div>
        </div>

        <div class="form-group">
          <label for="reset_confirm_new_password">Confirmar nueva contraseña</label>
          <div class="password-input-wrapper">
            <input id="reset_confirm_new_password" v-model="confirm_new_password" class="form-input"
              :type="show_confirm_password ? 'text' : 'password'">
            <i class="material-icons toggle-password-visibility" @click="toggleVisibility('show_confirm_password')">
              {{ show_confirm_password ? 'visibility_off' : 'visibility' }}
            </i>
          </div>
        </div>

        <div class="form-group checkbox-item">
          <input id="reset_confirm_change" v-model="confirm_change" type="checkbox" class="form-checkbox">
          <label for="reset_confirm_change">Estoy seguro de que quiero cambiar mi contraseña</label>
        </div>

        <button @click="from_hash_changePassword" class="btn btn--primary btn--full-width">GUARDAR</button>

        <div v-if="registration_success" class="success-message card-inset">
          <p>
            Ha cambiado la contraseña con éxito. Ya puede ingresar en la web con su usuario y contraseña a través de este enlace:
            <a href="/user/login" class="link">ACCEDER</a>
          </p>
        </div>
      </div>
      <div v-else class="info-message card-inset">
        <p>Para poder utilizar esta herramienta debe iniciar sesión.</p>
        <!-- Consider adding a login button/link here -->
         <a href="/user/login" class="btn btn--secondary">Iniciar Sesión</a>
      </div>
    </div>
  </div>
</template>

<script>
import APICaller from "@/components/codeComponents/APICaller.js";
import { mapGetters, mapMutations } from "vuex";
import PageHeader from "@/components/common/PageHeader.vue"; // Import PageHeader

export default {
  mixins: [APICaller],
  name: 'Password',
  components: {
    PageHeader // Register PageHeader
  },
  data() {
    return {
      old_password: '',
      new_password: '',
      user_email: '',
      confirm_new_password: '',
      confirm_change: false,
      show_old_password: false,
      show_new_password: false,
      show_confirm_password: false,
      url_flag: false,
      url_hash: '',
      registration_success: false,
    };
  },
  computed: {
    ...mapGetters(["_g_UserId"]),
    pageTitle() {
      return this._g_UserId != 0 ? 'Cambiar Contraseña' : 'Restablecer Contraseña';
    }
  },
  created() {
    this.urlMatchWith();
    this.getUrlHash();
  },
  methods: {
    changePassword: function () {
      if (this.checkToggleEnabled() && this.checkPasswordsAreEqual()) {
        let url = '/api/v1/change-password';
        const success = response => {
          if (response.data.success) {
            this.old_password = '';
            this.new_password = '';
            this.confirm_new_password = '';
            this.confirm_change = false; // Reset checkbox
            this.$vueOnToast.pop('success', 'La contraseña se ha actualizado con éxito.');
          }
          else {
            this.$vueOnToast.pop('error', response.data.info);
          }
        }
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('352', 'Error cambiando la contraseña');
        const params = new URLSearchParams;
        params.append('old_password', this.old_password);
        params.append('new_password', this.new_password);
        params.append('confirm_password', this.confirm_new_password);

        this._postAPICall(url, params, successHandler, failureHandler);
      }
    },
    from_hash_changePassword: function () {
      // Ensure email is fetched if not bound directly, though v-model should handle it.
      // this.user_email = document.getElementById("user-email").value; 
      if (this.new_password != "" && this.confirm_new_password != "" && this.user_email != "") {
        if (this.checkPasswordsAreEqual()) { // checkPasswordsAreEqual already includes the toggle check logic indirectly
          if(this.checkToggleEnabled()){
            let url = '/api/v1/from-hash-change-password';
            const success = response => {
              if (response.data.success) {
                this.user_email = '';
                this.new_password = '';
                this.confirm_new_password = '';
                this.confirm_change = false; // Reset checkbox
                this.registration_success = true;
                this.$vueOnToast.pop('success', response.data.info);
              }
              else {
                this.$vueOnToast.pop('error', response.data.info);
              }
            }
            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('352', 'Error cambiando la contraseña');
            const params = new URLSearchParams;
            params.append('user_email', this.user_email);
            params.append('new_password', this.new_password);
            params.append('confirm_password', this.confirm_new_password);
            params.append('hash', this.url_hash); // Make sure hash is sent

            this._postAPICall(url, params, successHandler, failureHandler);
          }
        }
      } else {
        this.$vueOnToast.pop('error', 'Por favor, rellene todos los campos.');
      }
    },
    toggleVisibility(property) {
      this[property] = !this[property];
      // No need to directly manipulate input type here if binding works as expected with :type
    },
    checkToggleEnabled() {
      if (this.confirm_change) {
        return true;
      }
      else {
        this.$vueOnToast.pop('error', 'Por favor, marque la casilla de confirmación.');
        return false;
      }
    },
    checkPasswordsAreEqual() {
      if (this.new_password === "") {
         this.$vueOnToast.pop('error', 'La nueva contraseña no puede estar vacía.');
        return false;
      }
      if (this.new_password === this.confirm_new_password) {
        return true;
      }
      else {
        this.$vueOnToast.pop('error', 'Las contraseñas no coinciden.');
        return false;
      }
    },
    urlMatchWith() {
      var url = window.location.href;
      // Simplified regex and ensure it checks for hash presence
      if (url.includes('/app/change-password/') && new URLSearchParams(window.location.search).has('hash')) {
        this.url_flag = true;
      } else {
        this.url_flag = false;
      }
    },
    getUrlHash() {
      var urlParams = new URLSearchParams(window.location.search);
      this.url_hash = urlParams.get('hash');
    }
  }
}
</script>

<style lang="scss" scoped>
// Assume global CSS variables are defined (:root or imported SCSS variables)
// Example:
// :root {
//   --color-background: #f8f9fa;
//   --color-surface: #ffffff;
//   --color-text-primary: #212529;
//   --color-text-secondary: #6c757d;
//   --color-primary: #007bff; // Or --color-highlight
//   --color-highlight: #00add9; // Example if you use highlight
//   --color-primary-alpha: rgba(0, 123, 255, 0.25);
//   --color-outline: #ced4da;
//   --color-error: #dc3545;
//   --color-success: #28a745;
//   --color-input-background: #fff;
//   --color-text-placeholder: #6c757d;
//   --color-text-on-highlight: #fff;
// }

.password-page-container {
  background-color: var(--color-background, #f8f9fa);
  color: var(--color-text-primary, #212529);
  padding: 20px 5%;
  min-height: 100vh;
  max-width: 600px; // Max width for the content area
  margin: 0 auto;
  box-sizing: border-box;
}

.password-content { // This is the main card
  &.card { // Ensure card styles are applied
    background-color: var(--color-surface, #ffffff);
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
    padding: 30px 35px;
    margin-top: 20px; // Space below PageHeader
    border: 1px solid var(--color-outline, #ced4da);
    display: flex;
    flex-direction: column;
    gap: 20px; // Space between form groups and button
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  label:not(.form-checkbox) { // Exclude checkbox labels from this specific styling if they are part of .form-group directly
    font-size: 0.875rem; // 14px
    font-weight: 500;
    color: var(--color-text-secondary, #6c757d);
  }
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;

  .form-input {
    padding-right: 45px; // Make space for the icon
  }
}

.toggle-password-visibility {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: var(--color-text-secondary, #6c757d);
  font-size: 24px; // Adjust icon size
  user-select: none; // Prevent text selection on icon click

  &:hover {
    color: var(--color-highlight, #00add9);
  }
}


.form-input,
.form-select { // Assuming you might have selects in other forms
  width: 100%;
  padding: 12px 15px;
  border: 1px solid var(--color-outline, #ced4da);
  border-radius: 6px;
  background-color: var(--color-input-background, #fff);
  color: var(--color-text-primary);
  font-size: 1rem; // 16px
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--color-highlight, #00add9); // Use highlight for focus
    box-shadow: 0 0 0 3px var(--color-primary-alpha, rgba(0, 123, 255, 0.25)); // Or highlight-alpha
  }

  &::placeholder {
    color: var(--color-text-placeholder, #6c757d);
    opacity: 0.7;
  }
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px; // Add some space before the checkbox

  label { // Label for the checkbox
    font-size: 0.9rem;
    color: var(--color-text-primary);
    cursor: pointer;
    font-weight: normal; // Reset weight if needed
  }
}

.form-checkbox {
  width: 20px;
  height: 20px;
  accent-color: var(--color-highlight, #00add9); // Use highlight for checkbox
  cursor: pointer;
}

.btn {
  padding: 12px 25px;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, filter 0.2s ease;
  border: 1px solid transparent;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &--primary {
    background-color: var(--color-highlight, #00add9);
    color: var(--color-text-on-highlight, #fff);
    border-color: var(--color-highlight, #00add9);

    &:hover {
      filter: brightness(90%);
    }
  }
  
  &--secondary {
    background-color: var(--color-surface, #fff);
    color: var(--color-highlight, #00add9);
    border-color: var(--color-highlight, #00add9);

    &:hover {
      background-color: var(--color-primary-alpha, rgba(25, 135, 84, 0.1)); // Assuming primary-alpha relates to highlight
    }
  }


  &--full-width {
    width: 100%;
  }
}

.success-message,
.info-message {
  &.card-inset { // Style for messages within the card
    padding: 15px;
    margin-top: 20px;
    border-radius: 6px;
    text-align: center;
    font-size: 0.95rem;
  }
}

.success-message {
  background-color: var(--color-success-bg, #d4edda); // Softer success background
  color: var(--color-success-text, #155724); // Darker success text
  border: 1px solid var(--color-success-border, #c3e6cb); // Success border
  
  p { margin: 0; }
  .link {
    color: var(--color-success-text, #155724); // Link color matching success text
    font-weight: bold;
    text-decoration: underline;
     &:hover {
       filter: brightness(80%);
     }
  }
}

.info-message {
  background-color: var(--color-info-bg, #e2e3e5); // Softer info background
  color: var(--color-info-text, #383d41);
  border: 1px solid var(--color-info-border, #d6d8db);
  p {
    margin-bottom: 15px; // Space between text and button
  }
}


// Remove or adapt old styles
/*
h1 { // Covered by PageHeader
    color: var(--color-text-primary);
}

.helper-input-parent { // Replaced by .form-group
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    width: 400px;
}

.helper-input { // Replaced by label in .form-group
    font-size: 12px;
}

.profile-input { // Replaced by .form-input
    width: 80%;
    height: 35px;
    border-radius: 5px;
    border: 1px solid #00000044;
    padding: 0px;
    background-color: white;
    box-sizing: border-box;
    font-size: 16px;
    padding-left: 10px;
    line-height: 35px;
}

.password-wrapper { // Replaced by .password-input-wrapper
    position: relative;
    display: flex;
    align-items: center;
}

.password-input { // Covered by .form-input within .password-input-wrapper
    padding-right: 40px;
}

.toggle-password { // Replaced by .toggle-password-visibility
    margin-left: 10px;
    cursor: pointer;
}

.helper-checkbox-parent { // Replaced by .form-group.checkbox-item
    margin-bottom: 20px;
}
.helper-checkbox-parent label {
    display: flex;
    align-items: flex-start;
}
.helper-checkbox-parent input { // Replaced by .form-checkbox
    accent-color: #009fc8;
}
.helper-checkbox-parent span { // Replaced by label for .form-checkbox
    font-size: 14px;
    width: 300px;
    display: inline-block;
}

.profile-button { // Replaced by .btn
    background-color: #00add9;
    border-radius: 20px;
    padding: 10px 50px;
    // ... other old styles
    width: 60%;
}

#change-password-container { // Replaced by .password-page-container
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.success-registration-container { // Replaced by .success-message.card-inset
    // ...
}
.success-registration-text {
    color: green;
    font-size: 14px;
}
.success-registration-text a{
    color: #00add9 !important;
}

// Other old styles like .from-hash-change-password-container, #main-container for iframe, etc.
// might need to be re-evaluated if that iframe part is still in use or can be simplified/removed.
// For now, focusing on the primary password change forms.
*/

</style>
  